<script setup lang="ts">
import { IconName } from '~/components/atoms/icon/Icon.vue'

withDefaults(defineProps<{ icon?: IconName }>(), {
  icon: 'textlink',
})
</script>
<template>
  <NuxtLink class="text-link text-small">
    <span class="text">
      <Icon :name="icon" />
      <slot>text link</slot>
      <Icon :name="icon" />
    </span>
  </NuxtLink>
</template>
<style scoped lang="scss">
.text-link {
  position: relative;
  overflow: hidden;
  display: inline-block;
}
.text {
  --icon-size: 1em;
  --gap: 8px;
  --amount: calc(var(--icon-size) + var(--gap));

  position: relative;
  display: block;
  padding-right: var(--amount);
  color: var(--c-primary);

  @include transitions(transform);

  &:before {
    content: '';
    position: absolute;
    top: 0;
    right: 100%;
    width: var(--amount);
    height: 100%;
  }

  :deep(svg) {
    position: absolute;
    top: 50%;
    transform: translate(0, -50%);
    @include transitions(opacity);

    width: var(--icon-size);
    height: var(--icon-size);
  }

  :deep(svg:first-child) {
    opacity: 0;
    right: calc(100% + var(--gap));
  }
  :deep(svg:last-child) {
    right: 0;
  }

  @include hover {
    transform: translate(var(--amount), 0);
    :deep(svg:first-child) {
      opacity: 1;
    }
    :deep(svg:last-child) {
      opacity: 0;
    }
  }
}
</style>
